<template>
  <div class="emendas-parlamentares">
    <div class="row">
      <div class="col-xs-12">
        <button
          type="button"
          class="btn btn-primary btn-voltar"
          @click="$router.back()"
        >
          <font-awesome-icon :icon="'arrow-left'" />
          Voltar
        </button>
        <h1 class="page-header">{{ label }} Emenda</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="col-xs-12 col-sm-4">
          <div :class="['form-group', { 'has-error': errors.has('numero') }]">
            <label
              :class="[
                'control-label',
                'primary',
                { 'is-danger': errors.has('numero') }
              ]"
              >Número da emenda</label
            >
            <div class="inputgroupcontainer">
              <div class="input-group">
                <span class="input-group-addon">
                  <font-awesome-icon
                    :icon="'sort-numeric-up-alt'"
                    :class="[{ 'is-danger': errors.has('numero') }]"
                  />
                </span>
                <the-mask
                  ref="numero"
                  v-model="model.numero"
                  name="numero"
                  data-vv-as="número da emenda"
                  placeholder="Número da emenda"
                  class="form-control"
                  v-validate="'required'"
                  maxlength="4"
                  :mask="'####'"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4">
          <div :class="['form-group', { 'has-error': errors.has('ano') }]">
            <label
              :class="[
                'control-label',
                'primary',
                { 'is-danger': errors.has('ano') }
              ]"
              >Ano</label
            >
            <div class="inputgroupcontainer">
              <div class="input-group">
                <span class="input-group-addon">
                  <font-awesome-icon
                    :icon="'calendar'"
                    :class="[{ 'is-danger': errors.has('ano') }]"
                  />
                </span>
                <the-mask
                  ref="ano"
                  v-model="model.ano"
                  name="ano"
                  placeholder="Ano"
                  class="form-control"
                  v-validate="'required'"
                  maxlength="4"
                  :mask="'####'"
                  type="text"
                />
                <div
                  :class="[
                    'input-group-addon custom-input-group-addon-count',
                    { 'is-danger': errors.has('ano') }
                  ]"
                  v-text="4 - model.ano.length"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4">
          <div
            :class="[
              'form-group',
              { 'has-error': errors.has('numero_processo') }
            ]"
          >
            <label
              :class="[
                'control-label',
                'primary',
                { 'is-danger': errors.has('numero_processo') }
              ]"
            >
              Número do processo
            </label>
            <div class="inputgroupcontainer">
              <div class="input-group">
                <span class="input-group-addon">
                  <font-awesome-icon
                    :icon="'sync-alt'"
                    :class="[{ 'is-danger': errors.has('numero_processo') }]"
                  />
                </span>
                <input
                  ref="numero_processo"
                  v-model="model.numero_processo"
                  name="numero_processo"
                  data-vv-as="número do processo"
                  placeholder="Número do processo com formato"
                  class="form-control"
                  v-validate="'required|min:9'"
                  maxlength="15"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div :class="['form-group', { 'has-error': errors.has('valor') }]">
            <label
              :class="[
                'control-label',
                'primary',
                { 'is-danger': errors.has('valor') }
              ]"
              >Valor</label
            >
            <div class="inputgroupcontainer">
              <div class="input-group">
                <span class="input-group-addon">
                  <font-awesome-icon
                    :icon="'money-bill'"
                    :class="[{ 'is-danger': errors.has('valor') }]"
                  />
                </span>
                <money
                  ref="valor"
                  v-model="model.valor"
                  name="valor"
                  placeholder="Valor da emenda"
                  class="form-control"
                  v-validate="'required|min_value:1.00'"
                  maxlength="22"
                  type="text"
                  v-bind="money"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div
            :class="['form-group', { 'has-error': errors.has('vereador_id') }]"
          >
            <label class="control-label primary">Vereador</label>
            <div class="custom-select">
              <select
                ref="vereador_id"
                class="form-control select-selected"
                name="vereador_id"
                data-vv-as="vereador"
                v-model="model.vereador_id"
                v-validate="'required'"
              >
                <option
                  v-for="vereador in vereadores"
                  :key="`vereador-${vereador.id}`"
                  :value="vereador.id"
                >
                  {{ vereador.nome }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div
            :class="['form-group', { 'has-error': errors.has('sigla_orgao') }]"
          >
            <label class="control-label primary">Sigla do orgão</label>
            <div class="custom-select">
              <select
                ref="sigla_orgao"
                class="form-control select-selected"
                name="sigla_orgao"
                data-vv-as="sigla do orgão"
                v-model="model.sigla_orgao"
                v-validate="'required'"
                @change="loadNomeOrgao"
              >
                <option v-for="orgao in orgaos" :key="orgao.id">
                  {{ orgao.sigla }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div class="form-group">
            <label class="primary">Nome do orgão</label>
            <div class="input-group">
              <span class="input-group-addon">
                <font-awesome-icon :icon="'signature'" />
              </span>
              <input
                ref="nome_orgoa"
                v-model="model.nome_orgao"
                name="nome_orgao"
                data-vv-as="nome do orgão"
                class="form-control"
                placeholder="Seleciona uma sigla"
                v-validate="'required'"
                type="text"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div class="form-group">
            <div>
              <label>Emenda destinada a entidade?</label>
            </div>
            <label class="block">
              <input
                type="radio"
                v-model="hasEntidade"
                :value="true"
                checked="checked"
              />
              Sim
            </label>
            <label class="block">
              <input
                type="radio"
                v-model="hasEntidade"
                :value="false"
                checked="checked"
                @click="limparEntidade"
              />
              Não
            </label>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6" v-if="hasEntidade">
          <div
            :class="[
              'form-group',
              { 'has-error': errors.has('nome_entidade') }
            ]"
          >
            <label class="control-label">
              Nome da entidade
            </label>
            <div class="input-group">
              <span class="input-group-addon">
                <font-awesome-icon :icon="'signature'" />
              </span>
              <input
                ref="nome_entidade"
                v-model="model.nome_entidade"
                name="nome_entidade"
                data-vv-as="nome da entidade"
                class="form-control"
                placeholder="Nome da entidade"
                v-validate="'required'"
                type="text"
              />
            </div>
          </div>
        </div>
        <div class="col-xs-12" style="min-height:95px">
          <div
            :class="['form-group', { 'has-error': errors.has('descricao') }]"
          >
            <label
              :class="[
                'control-label',
                'primary',
                { 'is-danger': errors.has('descricao') }
              ]"
              >Descrição</label
            >
            <div class="inputgroupcontainer">
              <div class="input-group">
                <span class="input-group-addon">
                  <font-awesome-icon
                    :icon="'tags'"
                    :class="[{ 'is-danger': errors.has('descricao') }]"
                  />
                </span>
                <textarea
                  ref="descricao"
                  rows="3"
                  name="descricao"
                  data-vv-as="descrição"
                  v-model="model.descricao"
                  placeholder="Descrição"
                  class="form-control"
                  maxlength="500"
                  v-validate="'required'"
                >
                </textarea>
                <div
                  :class="[
                    'input-group-addon custom-input-group-addon-count',
                    { 'is-danger': errors.has('descricao') }
                  ]"
                  v-text="500 - model.descricao.length"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12" style="min-height:95px">
          <div
            :class="[
              'form-group',
              { 'has-error': errors.has('resumo_utilizacao') }
            ]"
          >
            <label
              :class="[
                'control-label',
                'primary',
                { 'is-danger': errors.has('resumo_utilizacao') }
              ]"
              >Resumo de utilização</label
            >
            <div class="inputgroupcontainer">
              <div class="input-group">
                <textarea
                  ref="resumo_utilizacao"
                  rows="3"
                  name="resumo_utilizacao"
                  data-vv-as="resumo de utilização"
                  v-model="model.resumo_utilizacao"
                  placeholder="Resumo de utilização"
                  class="form-control"
                  maxlength="2000"
                >
                </textarea>
                <div
                  v-if="
                    model.resumo_utilizacao
                      ? model.resumo_utilizacao.length > 0
                      : ''
                  "
                  class="input-group-addon custom-input-group-addon-count"
                  v-text="2000 - model.resumo_utilizacao.length"
                ></div>
                <div
                  v-else
                  class="input-group-addon custom-input-group-addon-count"
                  v-text="2000"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12" style="min-height:95px">
          <div
            :class="['form-group', { 'has-error': errors.has('observacao') }]"
          >
            <label
              :class="[
                'control-label',
                'primary',
                { 'is-danger': errors.has('observacao') }
              ]"
              >Observação</label
            >
            <div class="inputgroupcontainer">
              <div class="input-group">
                <textarea
                  ref="observacao"
                  rows="3"
                  name="observacao"
                  data-vv-as="observação"
                  v-model="model.observacao"
                  placeholder="Observação"
                  class="form-control"
                  maxlength="2000"
                >
                </textarea>
                <div
                  v-if="model.observacao ? model.observacao.length > 0 : ''"
                  class="input-group-addon custom-input-group-addon-count"
                  v-text="2000 - model.observacao.length"
                ></div>
                <div
                  v-else
                  class="input-group-addon custom-input-group-addon-count"
                  v-text="2000"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12">
          <div
            :class="['form-group', { 'has-error': errors.has('termo_busca') }]"
          >
            <label
              :class="[
                'control-label',
                'primary',
                { 'is-danger': errors.has('termo_busca') }
              ]"
              >Termo de busca</label
            >
            <div class="inputgroupcontainer">
              <div class="input-group">
                <span class="input-group-addon">
                  <font-awesome-icon
                    :icon="'search'"
                    :class="[{ 'is-danger': errors.has('termo_busca') }]"
                  />
                </span>
                <input
                  ref="termo_busca"
                  v-model="model.termo_busca"
                  name="termo_busca"
                  data-vv-as="termo de busca"
                  placeholder="Termo de busca"
                  class="form-control"
                  maxlength="100"
                  type="text"
                />
                <div
                  v-if="model.termo_busca ? model.termo_busca.length > 0 : ''"
                  class="input-group-addon custom-input-group-addon-count"
                  v-text="100 - model.termo_busca.length"
                ></div>
                <div
                  v-else
                  class="input-group-addon custom-input-group-addon-count"
                  v-text="100"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group col-xs-12" style="margin-top:30px">
          <button
            @click="save()"
            class="btn btn-default"
            :disabled="carregando"
          >
            <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
            <font-awesome-icon v-else :icon="'save'" />
            Salvar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'
import { request } from '@/request'
import { PDFImport } from '@/components'

export default {
  name: 'emenda-save',
  components: {
    TheMask,
    PDFImport
  },
  data() {
    return {
      label: 'Adicionar',
      vereadores: [],
      orgaos: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      hasEntidade: false,
      model: {
        ano: '',
        nome_orgao: '',
        sigla_orgao: '',
        termo_busca: '',
        valor: '',
        numero: '',
        numero_processo: '',
        vereador_id: '',
        resumo_utilizacao: '',
        descricao: '',
        observacao: '',
        nome_entidade: ''
      },
      carregando: false
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  async mounted() {
    await this.loadVereadores()
    await this.loadOrgaos()

    const { id } = this.$route.params
    if (id) {
      this.label = 'Editar'
      this.loadModel(id)
    }
  },
  methods: {
    limparEntidade(e) {
      this.model.nome_entidade = ''
    },
    async fetchVereadores() {
      return await request.get('vereadores/listar-vereadores')
    },
    async loadVereadores() {
      const respVereador = await this.fetchVereadores()
      this.vereadores = respVereador.data
    },
    fetchSecretarias() {
      return request.get('unidade-organizacional/secretarias')
    },
    fetchOrgaos() {
      return request.get('unidade-organizacional/orgaos')
    },
    async loadOrgaos() {
      const { data } = await this.fetchOrgaos()
      this.orgaos = data
    },
    loadNomeOrgao() {
      const filter = o => o.sigla === this.model.sigla_orgao
      const [orgao] = this.orgaos.filter(filter)
      this.model.nome_orgao = orgao.nome
    },
    async loadModel(id) {
      const response = await request.get(`emenda/${id}`)

      this.model = response.data
      this.hasEntidade = !!this.model.nome_entidade
    },
    toogleLoading() {
      this.carregando = !this.carregando
    },
    saveSuccess(result) {
      this.$toastr.s('Emenda salva com sucesso.')
      this.$router.push({ name: 'user_emendasparlamentares' })
    },
    saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.')
      this.toogleLoading()
    },
    save() {
      this.toogleLoading()
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.toogleLoading()
          this.$refs[this.$validator.errors.items[0].field]
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }
        if (this.model.id) {
          request
            .put(`emenda/${this.model.id}`, this.model)
            .then(this.saveSuccess)
            .catch(this.saveFail)
        } else {
          request
            .post('emenda', this.model)
            .then(this.saveSuccess)
            .catch(this.saveFail)
        }
      })
    }
  }
}
</script>

<style scoped>
.block {
  display: block;
}

ul {
  padding: 0;
  list-style-type: none;
}

ul li {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #dddddd;
  color: black;
}

.panel-margin {
  margin-top: 10px;
}

.custom-check-label {
  color: #00615c;
}

.fa-calendar {
  color: #00615c;
}

.fa-search {
  color: #00615c;
}

.fa-money-bill {
  color: #00615c;
}

.fa-tags {
  color: #00615c;
}

.fa-sync-alt {
  color: #00615c;
}

.fa-sort-numeric-up-alt {
  color: #00615c;
}

.fa-calendar.is-danger {
  color: #990000;
}

.fa-search.is-danger {
  color: #990000;
}

.fa-money-bill.is-danger {
  color: #990000;
}

.fa-tags.is-danger {
  color: #990000;
}

.fa-sync-alt.is-danger {
  color: #990000;
}

.fa-sort-numeric-up-alt.is-danger {
  color: #990000;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/emendas-parlamentares/emendas/Save.vue